export default [
  {
    path: '/customer-service/faq',
    name: 'CustomerServiceFAQ',
    component: () => import('@/views/customerService/faq'),
    meta: {
      title: '常见问题',
      icon: 'question',
      keepAlive: true
    }
  },
  {
    path: '/customer-service/manual',
    name: 'CustomerServiceManual',
    component: () => import('@/views/customerService/manual'),
    meta: {
      title: '人工客服',
      icon: 'service',
      keepAlive: true
    }
  },
  {
    path: '/customer-service/ai',
    name: 'CustomerServiceAI',
    component: () => import('@/views/customerService/ai'),
    meta: {
      title: '智能客服',
      icon: 'robot'
    }
  },
  {
    path: '/customer-service/answer/:id',
    name: 'Answer',
    component: () => import('@/views/customerService/answerContainer.vue'),
    meta: {
      title: '回答详情'
    }
  }
]
